import type { ReactNode } from 'react';
import { IconChevronDown, IconChevronRight } from '../components/icons';

interface SubMenuProps {
  name: string;
  icon?: ReactNode;
  isOpen: boolean;
  /** Sidebar collapsed (icon-only) state. */
  collapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
}

// Collapsible nav group — adaptation of webapp2's MUI SubMenu.
export const SubMenu = ({ name, icon, isOpen, collapsed, onToggle, children }: SubMenuProps) => (
  <div className="nav-group">
    <button
      type="button"
      className={`nav-item nav-item--group${isOpen ? ' is-open' : ''}`}
      onClick={onToggle}
      title={collapsed ? name : undefined}
    >
      <span className="nav-item__icon">{icon}</span>
      {!collapsed && <span className="nav-item__label">{name}</span>}
      {!collapsed && (
        <span className="nav-item__chevron">
          {isOpen ? <IconChevronDown size={14} /> : <IconChevronRight size={14} />}
        </span>
      )}
    </button>
    {isOpen && !collapsed && <div className="nav-group__children">{children}</div>}
  </div>
);
